export default function quickSearch() {
    return {
        query: '',
        results: [],
        loading: false,
        searched: false,

        async search(scope) {

            if (this.query.length < 3) {
                this.results = [];
                this.searched = false;
                return;
            }

            this.loading = true;
            this.searched = true;

            try {
                const response = await fetch(
                    `/search/quick?q=${encodeURIComponent(this.query)}&scope=${scope}`
                );

                this.results = await response.json();
            } finally {
                this.loading = false;
            }
        },

        clear() {
            this.results = [];
            this.searched = false;
        },

        formatPrice(price) {
            return new Intl.NumberFormat('ru-RU').format(price);
        }
    }
}
